<template>
  <div id="app">
    
    <HelloWorld msg="Alan Leonard"/>
    <h4>UI Engineer | Front End Developer</h4>
    <a href="mailto:alan@alanleonard.net">Contact me</a>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

}
a {
  color: #6ec2b4;
  font-weight: bold;
}
</style>
